import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CardModule } from '@com-delta-idp/mnx-skymiles-shared';
import { ImageModule, LinkModule } from '@com-delta-idp/mnx-ui-kit';
import { QuickLinksComponent } from './quick-links.component';

@NgModule({
  declarations: [QuickLinksComponent],
  imports: [CommonModule, ImageModule, LinkModule, CardModule],
  exports: [QuickLinksComponent]
})
export class QuickLinksModule {}
